// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Uganda from '../_raw/flag/icon_flag_uganda.png';

export default () => <img src={Uganda} alt="Uganda" />;
